import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LocationProfile } from 'src/app/core/models/admin';
import { LocationService } from 'src/app/core/services/admin/location/location.service';

@Component({
  selector: 'app-route-admin',
  templateUrl: './route-admin.component.html',
  standalone: false,
})
export class RouteAdminComponent implements OnInit {
  destroy = inject(DestroyRef);
  private locationService = inject(LocationService);
  isIDO!: boolean;
  location!: LocationProfile;

  ngOnInit(): void {
    this.locationService
      .getCurrentLocation$()
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe((currentLocation) => {
        setTimeout(() => {
          if (currentLocation.location) {
            this.isIDO = currentLocation.location.routeDeliveryOrder || false;
            this.location = currentLocation.location;
          }
        }, 1000);
      });
  }
}
